// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_main_container {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.banner_container {
  width: 90%;
  padding: 80px, 88px, 80px, 88px;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  border-radius: 32px;
}
.customimage {
  width: 100%;
  display: block;
  margin: 20% 0% -20% 0%;
  height: auto;
}

/* Add this to your main CSS file or a specific CSS file that gets loaded on all pages */

/* Add this to your main CSS file or a specific CSS file that gets loaded on all pages */

.blur-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1040; /* Ensure it is below the modal but above other content */
  display: none;
}

.blur-overlay.show {
  display: block;
}


.banner_text {
  margin-top: 10%;
  font-family: "Poppins", sans-serif !important;
}

.wealth_btn {
  width: Hug (158px) px;
  height: Hug (40px) px;
  padding: 12px;
  color: white;
  font-family: inter;
  gap: 8px;
  border-radius: 8px;
  background: #ffffff1a;
  border: none;
}

.banner_text h2 {
  color: white;
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
}

.main_span {
  font-size: 58px;
  font-weight: 400;
  color: white;
  font-family: "Poppins", sans-serif !important;
}

.typed-text {
  font-size: 58px;
  font-weight: 600;
  color: white;
  font-family: "Poppins", sans-serif !important;
}

.typed-text_span {
  font-size: 0px;
}

.banner_pera p {
  color: white;
  margin-top: 52px;
  font-size: 20px;
  font-weight: 400;
  font-family: "inter", sans-serif !important;
}

.dn_btn {
  width: Hug (195.27px) px;
  margin-right: 10px;
  height: Fixed (52px) px;
  padding: 18px 18px 18px 18px;
  border: none;
  gap: 10px;
  border-radius: 9.45px;
  background: #f1e2ff;
  font-family: Sora;
  font-size: 16.55px;
  font-weight: 400;
  line-height: 20.68px;
  letter-spacing: 0.2954545319080353px;
  text-align: left;
}

.dn_btn_two {
  width: Hug (192.27px) px;
  height: Fixed (52px) px;
  background-color: transparent;
  color: white;
  padding: 18px 18px 18px 18px;
  gap: 10px;
  border-radius: 9.45px;
  border: none;
  font-family: Sora;
  font-size: 16.55px;
  font-weight: 400;
  line-height: 20.68px;
  letter-spacing: 0.2954545319080353px;
  text-align: left;
}

.dn_btn_two:hover {
  background-color: white;
  color: black;
}

.banner_btn {
  margin-right: 20px;
  margin-top: 52px;
  padding: 15px 40px;
  border: none;
  color: rgb(255, 255, 255);
  letter-spacing: 1.25px;
  font-size: 10px;
  font-family: poppins !important;
  font-weight: 600;
  background: linear-gradient(to right, #9e37ff 0%, #f237ff 100%);
}

.banner_four_btn_main {
  margin-top: 50px;
  display: flex;
  /* gap: 20px; */
}
.banner_four_btn_main_two {
  margin-top: 10px;
  display: flex;
  margin-bottom: 50px;
}

.banner_four_btn h2 {
  background-color: #a61bc2;
  padding: 10px 30px;
  font-size: 13px;
  font-weight: 400;
  color: white;
  font-family: "Poppins", sans-serif !important;
}

.four_button_div {
  margin-top: 50px;
}

.four_button_div h2 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  color: white;
}

.banner_buttons {
  width: Hug (214px) px;
  margin-right: 10px;
  height: Hug (46px) px;
  padding: 10px;
  color: white;
  gap: 8px;
  border-radius: 8px;
  border: 1px;
  background: #ffffff1a;
  border: 1px solid;

  border-image-source: linear-gradient(
    93.77deg,
    rgba(255, 255, 255, 0.24) -1.31%,
    rgba(255, 255, 255, 0.12) 101.53%
  );
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
}

@media (max-width: 768px) {
  .banner_text {
    margin-top: 10%;
    margin-bottom: 10px;
  }

  .banner_pera p{
    display: none;
    margin-top: 10px !important;
    font-size: 15px !important;
    text-align: center !important;
  }
  .four_button_div{
    margin-top: 10px !important;
    align-items: center !important;
    justify-content: center !important;
    display: flex !important;
  }
  .banner_four_btn_main{
    margin-top: 10px !important;
    display: flex;
    align-items: center;
    justify-content: center
  }

  .banner_four_btn_main_two{
    margin-bottom: 10px !important;
    align-items: center !important;
    justify-content: center !important;
    display: flex !important;
  }


  .dn_btn_two{
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .wealth_btn {
    padding: 12px;
    gap: 8px;
    border-radius: 8px;
    font-family: Inter;
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 1px;
    text-align: left;
  }

  .banner_design_text span {
    font-family: Sora;
    font-size: 30px;
    font-weight: 600;
    line-height: 46px;
    text-align: left;
  }
  .typed-text_span {
    font-size: 0px !important;
  }
  
  .banner_design_text {
    text-align: center; /* Centers the text */
  }
  .banner_btn_div,
  .banner_four_btn_main {
    text-align: center; /* Centers the text and content */
  }

  .banner_btn_div a,
  .banner_four_btn {
    display: block; /* Makes the anchor and div block level for center alignment */
    margin: 0 auto; /* Centers the block elements horizontally */
  }

  .banner_four_btn {
    width: 45%; /* Ensures each button stretches to full container width */
    box-sizing: border-box; /* Includes padding and border in the width */
  }
  .banner_pera p {
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    text-align: left;
  }

  .banner_text h2,
  .banner_four_btn h2 {
    font-size: 14px;
    text-align: left;
  }

  .typed-text {
    font-size: 22px; /* Smaller font size for smaller screens */
  }
  .main_span {
    font-size: 25px;
  }
  .dn_btn {
    font-family: Sora;
    font-size: 16.55px;
    font-weight: 400;
    line-height: 20.68px;
    letter-spacing: 0.2954545319080353px;
  }

  .banner_btn {
    padding: 10px 20px;
    font-size: 12px;
  }

  .banner_four_btn_main{
    flex-wrap: wrap;
    display: flex;
    /* flex-direction: column; */
    gap: 10px;
    /* width: 40%; */
    margin-bottom: 30px;
  }
  .banner_four_btn_main_two{
    flex-wrap: wrap;
    display: flex;
    /* flex-direction: column; */
    gap: 0px;
    /* width: 40%; */
    margin-bottom: 30px;

  }
  .banner_four_btn h2 {
    padding: 10px 20px;
    font-size: 12px; /* Smaller font size for smaller screens */
  }

  .customimage {
    
    margin: 0% 0% 0% 0%;
  }
  .four_button_div h2 {
    font-family: Inter;
    font-size: 14px;
    margin-left: 5px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
  .banner_buttons {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    width: Hug (194px) px;
    height: Hug (40px) px;
    padding: 8px 10px 8px 10px;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid #ffffff3d;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
  .banner_buttons img {
    margin-right: 5px;
  }
  .banner_four_btn_main_two {
    margin-top: -30px;
  }
  .banner_four_btn_main_two .banner_buttons {
    margin-top: 10px;
  }
  
}
@media (max-width: 475px) {
  .wealth_btn {
    margin-left: 1.7rem;
  }
  .hero-calendly {
    margin-top: 1.5rem !important;
    margin-bottom: 3rem;
    padding: 0 2rem;
  }
}

@media screen and (min-width: 1024px) {
  .hero-calendly {
    margin-top: 3rem !important;
  };
}`, "",{"version":3,"sources":["webpack://./src/Banner/banner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA,wFAAwF;;AAExF,wFAAwF;;AAExF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;EAC3B,oCAAoC;EACpC,aAAa,EAAE,yDAAyD;EACxE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;;EAEjB;;;;GAIC;EACD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;IAClC,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB;EACF;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,kCAAkC;IAClC,wBAAwB;EAC1B;;;EAGA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB,EAAE,qBAAqB;EAC3C;EACA;;IAEE,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA;;IAEE,cAAc,EAAE,8DAA8D;IAC9E,cAAc,EAAE,4CAA4C;EAC9D;;EAEA;IACE,UAAU,EAAE,0DAA0D;IACtE,sBAAsB,EAAE,6CAA6C;EACvE;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe,EAAE,0CAA0C;EAC7D;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,aAAa;IACb,4BAA4B;IAC5B,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,eAAe,EAAE,0CAA0C;EAC7D;;EAEA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,0BAA0B;IAC1B,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;;AAEF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B,CAAA;AACF","sourcesContent":[".banner_main_container {\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n}\n.banner_container {\n  width: 90%;\n  padding: 80px, 88px, 80px, 88px;\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n  border-radius: 32px;\n}\n.customimage {\n  width: 100%;\n  display: block;\n  margin: 20% 0% -20% 0%;\n  height: auto;\n}\n\n/* Add this to your main CSS file or a specific CSS file that gets loaded on all pages */\n\n/* Add this to your main CSS file or a specific CSS file that gets loaded on all pages */\n\n.blur-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(10px);\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 1040; /* Ensure it is below the modal but above other content */\n  display: none;\n}\n\n.blur-overlay.show {\n  display: block;\n}\n\n\n.banner_text {\n  margin-top: 10%;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.wealth_btn {\n  width: Hug (158px) px;\n  height: Hug (40px) px;\n  padding: 12px;\n  color: white;\n  font-family: inter;\n  gap: 8px;\n  border-radius: 8px;\n  background: #ffffff1a;\n  border: none;\n}\n\n.banner_text h2 {\n  color: white;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.main_span {\n  font-size: 58px;\n  font-weight: 400;\n  color: white;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.typed-text {\n  font-size: 58px;\n  font-weight: 600;\n  color: white;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.typed-text_span {\n  font-size: 0px;\n}\n\n.banner_pera p {\n  color: white;\n  margin-top: 52px;\n  font-size: 20px;\n  font-weight: 400;\n  font-family: \"inter\", sans-serif !important;\n}\n\n.dn_btn {\n  width: Hug (195.27px) px;\n  margin-right: 10px;\n  height: Fixed (52px) px;\n  padding: 18px 18px 18px 18px;\n  border: none;\n  gap: 10px;\n  border-radius: 9.45px;\n  background: #f1e2ff;\n  font-family: Sora;\n  font-size: 16.55px;\n  font-weight: 400;\n  line-height: 20.68px;\n  letter-spacing: 0.2954545319080353px;\n  text-align: left;\n}\n\n.dn_btn_two {\n  width: Hug (192.27px) px;\n  height: Fixed (52px) px;\n  background-color: transparent;\n  color: white;\n  padding: 18px 18px 18px 18px;\n  gap: 10px;\n  border-radius: 9.45px;\n  border: none;\n  font-family: Sora;\n  font-size: 16.55px;\n  font-weight: 400;\n  line-height: 20.68px;\n  letter-spacing: 0.2954545319080353px;\n  text-align: left;\n}\n\n.dn_btn_two:hover {\n  background-color: white;\n  color: black;\n}\n\n.banner_btn {\n  margin-right: 20px;\n  margin-top: 52px;\n  padding: 15px 40px;\n  border: none;\n  color: rgb(255, 255, 255);\n  letter-spacing: 1.25px;\n  font-size: 10px;\n  font-family: poppins !important;\n  font-weight: 600;\n  background: linear-gradient(to right, #9e37ff 0%, #f237ff 100%);\n}\n\n.banner_four_btn_main {\n  margin-top: 50px;\n  display: flex;\n  /* gap: 20px; */\n}\n.banner_four_btn_main_two {\n  margin-top: 10px;\n  display: flex;\n  margin-bottom: 50px;\n}\n\n.banner_four_btn h2 {\n  background-color: #a61bc2;\n  padding: 10px 30px;\n  font-size: 13px;\n  font-weight: 400;\n  color: white;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.four_button_div {\n  margin-top: 50px;\n}\n\n.four_button_div h2 {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: left;\n  color: white;\n}\n\n.banner_buttons {\n  width: Hug (214px) px;\n  margin-right: 10px;\n  height: Hug (46px) px;\n  padding: 10px;\n  color: white;\n  gap: 8px;\n  border-radius: 8px;\n  border: 1px;\n  background: #ffffff1a;\n  border: 1px solid;\n\n  border-image-source: linear-gradient(\n    93.77deg,\n    rgba(255, 255, 255, 0.24) -1.31%,\n    rgba(255, 255, 255, 0.12) 101.53%\n  );\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: left;\n}\n\n@media (max-width: 768px) {\n  .banner_text {\n    margin-top: 10%;\n    margin-bottom: 10px;\n  }\n\n  .banner_pera p{\n    display: none;\n    margin-top: 10px !important;\n    font-size: 15px !important;\n    text-align: center !important;\n  }\n  .four_button_div{\n    margin-top: 10px !important;\n    align-items: center !important;\n    justify-content: center !important;\n    display: flex !important;\n  }\n  .banner_four_btn_main{\n    margin-top: 10px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center\n  }\n\n  .banner_four_btn_main_two{\n    margin-bottom: 10px !important;\n    align-items: center !important;\n    justify-content: center !important;\n    display: flex !important;\n  }\n\n\n  .dn_btn_two{\n    width: 100%;\n    text-align: center;\n    margin-top: 20px;\n  }\n  .wealth_btn {\n    padding: 12px;\n    gap: 8px;\n    border-radius: 8px;\n    font-family: Inter;\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 1px;\n    text-align: left;\n  }\n\n  .banner_design_text span {\n    font-family: Sora;\n    font-size: 30px;\n    font-weight: 600;\n    line-height: 46px;\n    text-align: left;\n  }\n  .typed-text_span {\n    font-size: 0px !important;\n  }\n  \n  .banner_design_text {\n    text-align: center; /* Centers the text */\n  }\n  .banner_btn_div,\n  .banner_four_btn_main {\n    text-align: center; /* Centers the text and content */\n  }\n\n  .banner_btn_div a,\n  .banner_four_btn {\n    display: block; /* Makes the anchor and div block level for center alignment */\n    margin: 0 auto; /* Centers the block elements horizontally */\n  }\n\n  .banner_four_btn {\n    width: 45%; /* Ensures each button stretches to full container width */\n    box-sizing: border-box; /* Includes padding and border in the width */\n  }\n  .banner_pera p {\n    font-family: Inter;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 32px;\n    text-align: left;\n  }\n\n  .banner_text h2,\n  .banner_four_btn h2 {\n    font-size: 14px;\n    text-align: left;\n  }\n\n  .typed-text {\n    font-size: 22px; /* Smaller font size for smaller screens */\n  }\n  .main_span {\n    font-size: 25px;\n  }\n  .dn_btn {\n    font-family: Sora;\n    font-size: 16.55px;\n    font-weight: 400;\n    line-height: 20.68px;\n    letter-spacing: 0.2954545319080353px;\n  }\n\n  .banner_btn {\n    padding: 10px 20px;\n    font-size: 12px;\n  }\n\n  .banner_four_btn_main{\n    flex-wrap: wrap;\n    display: flex;\n    /* flex-direction: column; */\n    gap: 10px;\n    /* width: 40%; */\n    margin-bottom: 30px;\n  }\n  .banner_four_btn_main_two{\n    flex-wrap: wrap;\n    display: flex;\n    /* flex-direction: column; */\n    gap: 0px;\n    /* width: 40%; */\n    margin-bottom: 30px;\n\n  }\n  .banner_four_btn h2 {\n    padding: 10px 20px;\n    font-size: 12px; /* Smaller font size for smaller screens */\n  }\n\n  .customimage {\n    \n    margin: 0% 0% 0% 0%;\n  }\n  .four_button_div h2 {\n    font-family: Inter;\n    font-size: 14px;\n    margin-left: 5px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n  }\n  .banner_buttons {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    width: Hug (194px) px;\n    height: Hug (40px) px;\n    padding: 8px 10px 8px 10px;\n    gap: 8px;\n    border-radius: 8px;\n    border: 1px solid #ffffff3d;\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n  }\n  .banner_buttons img {\n    margin-right: 5px;\n  }\n  .banner_four_btn_main_two {\n    margin-top: -30px;\n  }\n  .banner_four_btn_main_two .banner_buttons {\n    margin-top: 10px;\n  }\n  \n}\n@media (max-width: 475px) {\n  .wealth_btn {\n    margin-left: 1.7rem;\n  }\n  .hero-calendly {\n    margin-top: 1.5rem !important;\n    margin-bottom: 3rem;\n    padding: 0 2rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .hero-calendly {\n    margin-top: 3rem !important;\n  };\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
